import ToasterService from '../mybus/services/toaster';
import ToastSchema from '../mybus/schema/toaster.schema';
import Translate from './translate';

/**
 * ------------
 * Form
 * ------------
 * gère les formulaires
 */
export default class Form {

    constructor() {
        Form.input();
        Form.select();
        Form.contactForm7();
    }

    /**
     * ----------------
     * input
     * ----------------
     * Initialise les checkbox et radio
     */
    static input() {
        let $elements = $('.wpcf7 [type="checkbox"], .wpcf7 [type="radio"]');

        $($elements).each(function (index, element) {
            let id = $(element).attr('name') + '-' + index;
            let label_text = $(element).siblings('.wpcf7-list-item-label').text();
            let label = '<label for="' + id + '">' + label_text + '</label>';

            $(element).siblings('.wpcf7-list-item-label').remove();
            $(element).parent().append(label);
            $(element).attr('id', id);
        });
    }

    /**
     * ----------------
     * select
     * ----------------
     * ajoute un wrapper autour des select
     */
    static select() {
        $('select').parent().not('.formSelect').children('select').wrap('<div class="formSelect"></div>');
    }

    /**
     * ----------------
     * contactForm7
     * ----------------
     * gère la validation des formulaires de contact & newsletter
     */
    static contactForm7 = function() {
        const wpcf7Elm = document.querySelector( '.wpcf7' );

        if( wpcf7Elm ) {
            wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
                const response = event.detail.apiResponse;
                if( response.status === "validation_failed" ) {
                    Form.invalidField(wpcf7Elm, response.invalid_fields);
                } else {
                    // remove all errors
                    $( ".wpcf7 input, .wpcf7 textarea" ).removeClass('withError');
                    $( ".axeptio_mount" ).removeClass('withError');

                    // toaster
                    let message = '';
                    let titre = '';
                    switch( Theme.page_list.CURRENT_PAGE ) {
                        case Theme.page_list.PAGE_CONTACT:
                            titre = Translate.print('form.contact.title');
                            message = Translate.print('form.contact.valid');
                            break;
                        case Theme.page_list.PAGE_NEWSLETTER:
                            titre = Translate.print('form.newsletter.title');
                            message = Translate.print('form.newsletter.valid');
                            break;
                        default:
                            titre = Translate.print('form.default.title');
                            message = Translate.print('form.default.valid');
                            break;
                    }
                    const content = {
                        title: titre,
                        text: message,
                        status: 'valid'
                    }
                    ToasterService.showToaster(new ToastSchema(content));
                    setTimeout(function() {
                        $( '.wpcf7-response-output' ).html(message);
                    }, 0);
                }
            }, false );
        }
    }

    /**
     * ---------------
     * invalidField
     * ---------------
     * Met en évidence les champs avec une erreur et affiche un toaster
     */
    static invalidField = function(form, fields) {
        // remove all errors
        $( ".wpcf7 input, .wpcf7 textarea" ).removeClass('withError');
        $( ".axeptio_mount" ).removeClass('withError');

        // toaster + highlight field error
        let errorMessage = "";
        if( fields.length > 1 ) {
            errorMessage = Translate.print('form.default.invalid');
        }

        let message = "";
        $.each( fields, function(index, item) {
            const name = item.into.split('.')[2];
            const label = $( "#" + name ).parent().children("label").html();

            if( name.includes('axeptio') ) {
                $( ".axeptio_mount" ).addClass('withError');
                message += Translate.print('form.default.reason_politique');
            } else {
                $( "#" + name ).addClass('withError');
                if( item.message.includes("n’est pas valide") ) {
                    message += Translate.print('form.default.reason_field') + label + Translate.print('form.default.reason_invalid');
                } else {
                    message += Translate.print('form.default.reason_field') + label + Translate.print('form.default.reason_empty');
                }

            }
        } );
        errorMessage += message;
        setTimeout(function() {
            $( '.wpcf7-response-output' ).html(errorMessage);
        }, 0);

        let titre = '';
        switch( Theme.page_list.CURRENT_PAGE ) {
            case Theme.page_list.PAGE_CONTACT:
                titre = Translate.print('form.contact.title');
                break;
            case Theme.page_list.PAGE_NEWSLETTER:
                titre = Translate.print('form.newsletter.title');
                break;
            default:
                titre = Translate.print('form.default.title');
                break;
        }
        const content = {
            title: titre,
            text: errorMessage,
            status: 'alert'
        }
        ToasterService.showToaster(new ToastSchema(content));
    }
}